/**
 * LiquidityRatiosPrint — impression « Ratio de liquidité ».
 * Réutilise le COMPOSANT RÉEL de l'écran (FinancialsWorkingCapitalTab,
 * section='liquidity') : mêmes tables (cascade des valeurs nettes par degré +
 * les 3 ratios avec cibles), mêmes en-têtes. Unité = celle du hub Rapports
 * (kCHF par défaut, comme les autres rapports imprimés).
 */
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import FinancialsWorkingCapitalTab from '../FinancialsWorkingCapitalTab';
import { usePersistentValue } from '../../hooks/usePersistentState';
import { p } from '../../i18n/useP';
import PrintReportHeader from '../hr/print/PrintReportHeader';
import '../hr/print/PeoplePrint.css';
import './financialsScreenPrint.css';

export default function LiquidityRatiosPrint({ activeTenant, year, editedAt, onDataReady, cutoff = null }) {
  const { t } = useTranslation();
  const tenantId = activeTenant?.id;
  const [unit] = usePersistentValue(`fin_reports_unit_${tenantId}`, 'kchf');
  const done = useRef(false);
  const ready = () => { if (!done.current) { done.current = true; if (onDataReady) onDataReady('liquidity-ratios'); } };

  return (
    <section className="ppl-print__section ppl-print__section--wide fin-screenprint">
      <PrintReportHeader category={p('Rapport financier')} title={t('print:reports.liquidity-ratios')} year={year} unit={unit} tenant={activeTenant} editedAt={editedAt} />
      <FinancialsWorkingCapitalTab activeTenant={activeTenant} year={year} section="liquidity" cutoff={cutoff} unit={unit} onReady={ready} />
    </section>
  );
}
